// Generated by DesignToCode

import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  PLATFORM_ID,
  inject,
  input,
  signal,
} from '@angular/core';
import { MenuItem, Status } from '../../ui/menu-item/menu-item';
import { PrimaryButton, PrimaryButtonSize } from '../../ui/primary-button/primary-button';

interface NavItem {
  label: string;
  sectionId: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, PrimaryButton, MenuItem],
  templateUrl: './header.html',
})
export class Header implements AfterViewInit, OnDestroy {
  // Inputs
  public primaryButtonLabel = input<string>('Coding Challenge');
  public primaryButtonSize = input<PrimaryButtonSize>('medium');

  public activeSection = signal<string>('who-we-are');

  public navItems: NavItem[] = [
    { label: 'Who we Are', sectionId: 'who-we-are' },
    { label: 'Office', sectionId: 'office' },
    { label: 'Day-to-Day', sectionId: 'day-to-day' },
    { label: 'Tech Stack', sectionId: 'tech-stack' },
    { label: 'Culture', sectionId: 'culture' },
    { label: 'Join Us', sectionId: 'join-us' },
  ];

  private readonly scrollOffset = 120;
  private readonly scrollPadding = 50;
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private rafId: number | null = null;

  private updateActiveSection(): void {
    if (!this.isBrowser) return;

    let active = this.navItems[0].sectionId;
    for (const item of this.navItems) {
      const el = document.getElementById(item.sectionId);
      if (el && el.getBoundingClientRect().top <= this.scrollOffset) {
        active = item.sectionId;
      }
    }
    this.activeSection.set(active);
  }

  private readonly onScroll = (): void => {
    if (this.rafId !== null) return;
    this.rafId = requestAnimationFrame(() => {
      this.updateActiveSection();
      this.rafId = null;
    });
  };

  public ngAfterViewInit(): void {
    if (!this.isBrowser) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  public ngOnDestroy(): void {
    if (!this.isBrowser) return;

    window.removeEventListener('scroll', this.onScroll);
    if (this.rafId !== null) cancelAnimationFrame(this.rafId);
  }

  public scrollToSection(sectionId: string): void {
    if (!this.isBrowser) return;

    const el = document.getElementById(sectionId);
    if (el) {
      const top =
        el.getBoundingClientRect().top + window.scrollY - this.scrollOffset + this.scrollPadding;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  public getStatus(sectionId: string): Status {
    return this.activeSection() === sectionId ? 'active' : 'default';
  }

  public navigateToChallenge(): void {
    if (!this.isBrowser) return;

    window.open(
      'https://medium.com/fromscratch-studio/skip-the-first-interview-show-us-your-skills-instead-ca02bc1af136',
      '_blank',
    );
  }
}
